export default "__VITE_PUBLIC_ASSET__c8c5c2d9__"